import React, { RefObject, forwardRef } from "react";
import { createPortal } from "react-dom";
import { Box, IconButton, Stack, Tooltip, useTheme } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";

export const hideChecklistFooter = (containerElement: HTMLElement) => {
    const checklistFooter =
        containerElement.lastElementChild?.shadowRoot?.querySelector(
            ".productfruits--checklist-panel-footer"
        );

    checklistFooter?.setAttribute("style", "display: none");
};

export const showChecklistContainer = (containerElement: HTMLElement) => {
    if (!!containerElement) {
        hideChecklistFooter(containerElement);
        containerElement.setAttribute("style", "transform: scale(1)");
    }
};

export const hideChecklistContainer = (containerElement: HTMLElement) => {
    if (!!containerElement) {
        containerElement.setAttribute("style", "transform: scale(0)");
    }
};

export const showChecklistError = (
    containerElement: HTMLElement,
    message: string
) => {
    if (!!containerElement) {
        const errorContainer = containerElement.querySelector(
            ".ProductFruitsChecklist-error"
        );
        const errorMessageContainer = containerElement.querySelector(
            ".ProductFruitsChecklist-error-message"
        );

        errorMessageContainer.textContent = message;
        errorContainer.setAttribute("style", "display: flex");
    }
};

export const hideChecklistError = (containerElement: HTMLElement) => {
    if (!!containerElement) {
        const errorContainer = containerElement.querySelector(
            ".ProductFruitsChecklist-error"
        );

        errorContainer.setAttribute("style", "display: none");
    }
};

const ProductFruitsChecklistContainer = forwardRef(
    (props, ref: RefObject<HTMLElement>) => {
        const muiTheme = useTheme();
        const theme = useTheme();
        return createPortal(
            <Box
                className="ProductFruitsChecklist-container"
                sx={{
                    position: "fixed",
                    left: "16px",
                    bottom: "16px",
                    zIndex: 10,
                    boxShadow: `${muiTheme?.shadows[10]} !important`,
                    borderRadius: "8px",
                    border: `2px solid ${theme?.custom?.borderGrey}`,
                    overflow: "hidden",
                    transform: "scale(0)",
                    transition: muiTheme.transitions.create("transform", {
                        duration: 200,
                    }),
                    transformOrigin: "bottom left",
                }}
                ref={ref}
            >
                <Tooltip
                    title="Close"
                    sx={{
                        alignSelf: "flex-end",
                        position: "absolute",
                        top: 14,
                        right: 10,
                        zIndex: 10000011,
                    }}
                >
                    <IconButton
                        onClick={() => {
                            hideChecklistContainer(ref.current);
                        }}
                    >
                        <CancelOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Stack
                    className="ProductFruitsChecklist-error"
                    sx={{
                        width: "400px",
                        height: "400px",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "none",
                        backgroundColor: theme?.custom?.white,
                    }}
                >
                    <AnnouncementOutlinedIcon
                        sx={{
                            fontSize: "150px",
                            color: theme?.custom?.disabledColor,
                        }}
                    />
                    <Box className="ProductFruitsChecklist-error-message" />
                </Stack>
            </Box>,
            document.body
        );
    }
);

export default ProductFruitsChecklistContainer;
